import React from 'react';
import { InjectedRouter, browserHistory } from 'react-router';
import { consume } from 'lib/queryParams';
import * as CoachingActions from 'coaching/actions/CoachingActions';
import CoachingConstants from 'coaching/CoachingConstants';
import { withRouter } from 'app/context/Router';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';

type Props = {
  router: InjectedRouter;
};

class AcceptCoachingInvitation extends React.Component<Props> {
  async componentDidMount() {
    const { router } = this.props;
    const { success } = await CoachingActions.acceptCoachingInvitation();
    if (success) {
      const { redirectAfterAccept } = consume(browserHistory, ['redirectAfterAccept']);
      if (redirectAfterAccept) {
        window.location.href = redirectAfterAccept;
      }

      router.push(CoachingConstants.COACHING_HOME_ROUTE);
    } else {
      router.push('/classes');
    }
  }

  render() {
    return <CenteredLoadingIndicator />;
  }
}

export { AcceptCoachingInvitation };

export default withRouter(AcceptCoachingInvitation);
